import { render, staticRenderFns } from "./EditRewardItemActualPriceDialog.vue?vue&type=template&id=6db10101"
import script from "./edit-reward-item-actual-price-dialog.ts?vue&type=script&lang=ts&external"
export * from "./edit-reward-item-actual-price-dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports